<template>
  <div class="kqi-paper-list-template">
    <div class="paper-list-table">
      <!-- 散点图 update -->
      <div id="scatter-map"></div>
      <ul>
        <li>
          <div class="first chidren">
            <div class="author item">
              Title
            </div>
            <div class="affiliation item">
              Author
            </div>
            
            <div
              class="citation_share item"
            >
              Citation
            </div>
            <div
              class="t2citation item"
            >
              KQI(*10^6)
            </div>
            <div
              class="venue item"
            >
              Venue
            </div>
          <div
              class="hindex item"
            >
              Year
            </div>
          </div>
        </li>
        <li v-for="(item, index) in paperData" :key="index" @click.stop="handleChangeTind(index)">
          <div class="chidren">
            <div class="author item">
              <span
                :class="[activeChildInd === index ?'el-icon-caret-bottom':'el-icon-caret-right', 'green']"
              ></span>
              <span class="paper-name">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.title"
                  placement="left"
                >
                  <span class="paper-name-white-space">{{item.title}}</span>
                </el-tooltip>
              </span>
              <!-- (
              <span class="paper-affiliation">
                <el-tooltip effect="dark" :content="item.affiliation" placement="top-start">
                  <span>{{ item.affiliation }}</span>
                </el-tooltip>
              </span>) -->
              <!-- <span class="paper-logo" @click.stop="gotoAuthorView(item)">
                <span class="logo"></span>
              </span> -->
            </div>
            <div class="affiliation item">
              <span class="paper-affiliation">
                  {{ item.author.length ? item.author[0] : '' }}
              </span>
            </div>
            <div class="count item">{{item.citation}}</div>
            <div class="citation item">{{item.kqi}}</div>
            <div class="venue item">
              <el-tooltip effect="dark" class="item" :content="item.venue" placement="top-start">
                  <span class="paper-venue-white-space">{{item.venue}}</span>
              </el-tooltip>
            </div>
            <div class="citation_share item">{{item.year}}</div>
            <!-- <div class="citation_share item">{{item.kqi.toFixed(3)}}</div> -->
          </div>
          <div class="paper-detail" v-if="activeChildInd === index">
            <el-row>
                <span class="label">Authors: </span>
                <span class="value">{{ paperInfo.author.length ? item.author.join(', ') : '-'}}</span>
            </el-row>
            <el-row>
              <span class="label">Abstract: </span>
              <span class="value">{{ paperInfo.abstract }}</span>
            </el-row>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  props: {
    tableData: {
      type: Array,
      default: function () {
        return [];
      }
    },
    chartData: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  data () {
    return {
      activeChildInd: -1,
      paperData: [],
    };
  },
  watch: {
    tableData: {
      handler: function (val, oldVal) {
        this.paperData = this.tableData || [];
      },
      deep: true,
      immediate: true
    },
    chartData() {
      this.$nextTick(() => {
        this.drawScatterChart()
      })  
    }
  },
  methods: {
    drawAuthorLine (id, xData, yData) {
      let myChart = echarts.init(document.getElementById(id));
      // 绘制图表
      let _this = this;
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          //   left: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            axisTick: {
              show: false
            },
            axisLine: {
              show: true
            },
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            show: false
          }
        ],
        series: [
          {
            name: "publication count",
            type: "bar",
            barWidth: 10,
            data: yData,
            itemStyle: {
              normal: {
                color: function (params) {
                  //首先定义一个数组
                  var colorList = ["#398DEE", "rgba(57,141,238,0.5)"];
                  if (params.dataIndex % 2 == 0) {
                    return colorList[0];
                  } else {
                    return colorList[1];
                  }
                }
              }
            }
          }
        ]
      });
    },
    drawChart (id, data) {
      // 饼图
      let myChart = echarts.init(document.getElementById(id));
      let _this = this;
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          show: false,
          orient: "vertical",
          left: "right",
          data: data.name
        },
        series: [
          {
            name: "Proportion",
            type: "pie",
            radius: "60%",
            center: ["50%", "50%"],
            data: data.list,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
    },
    // 绘制散点图
    drawScatterChart() {
      var chartDom = document.getElementById("scatter-map");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          position: 'top',
          formatter: function (params) {
            return `
              Paper: ${params.value[2]}
              <br/>
              Citation: ${params.value[0]}
              <br/>
              KQI: ${params.value[1]}
              `
          }
        },
        xAxis: {
          name: 'Citation',
          nameTextStyle: {
            fontSize: 16,
            fontWeight: 'bolder'
          },
        },
        yAxis: {
          name: 'KQI',
          nameTextStyle: {
            fontSize: 16,
            fontWeight: 'bolder'
          },
        },
        series: [
          {
            symbolSize: 20,
            data:  this.chartData,
            type: "scatter",
            itemStyle: {
              color: '#0274b3'
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    gotoPaperList (item) {
      let routeData = this.$router.resolve({
        path: `/paper/${item.paper_id}`
      });
      window.open(routeData.href, "_blank");
    },
    handleChangeTind (index) {
      if (this.activeChildInd === index) {
        this.activeChildInd = -1;
      } else {
        this.activeChildInd = index;
        this.paperInfo = this.paperData[index]
      }
    },
  }
};
</script>

<style lang="less" scoped>
.click_active {
  &:active {
    opacity: 0.5;
  }
}
.kqi-paper-list-template {
  width: 100%;
  .paper-list-table {
    width: 100%;
    .green {
      color: #398dee;
      &:hover {
        cursor: pointer;
      }
    }
    .first {
      display: flex;
      justify-content: space-between;
      height: 48px;
      line-height: 48px;
      font-size: 20px;
      color: #a0a0a0;
      background: #f7f8fa;
      .author {
        padding-left: 0;
        text-indent: 20px;
      }
    }
    ul > li {
      width: 100%;
      border-bottom: 1px solid #eeeeee;
      .chidren {
        width: 100%;
        height: 70px;
        line-height: 70px;
        display: flex;
        justify-content: space-between;
        .item {
          text-align: center;
          font-size: 15px;
          .click_active;
          &:hover {
            cursor: pointer;
          }
        }
        .author {
          width: 20%;
          display: flex;
          justify-content: flex-start;
          text-align: left;
          .green {
            display: inline-block;
            padding: 0 1px;
            box-sizing: border-box;
            height: 100%;
            line-height: 70px;
          }
          .paper-name {
            display: block;
            width: 100%;
            padding: 0 2px 0 1px;
            box-sizing: border-box;
            height: 100%;
            .paper-name-white-space {
              max-width: 100%;
              display: block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: left;
              padding-left: 8px;
            }
          }
          .paper-affiliation {
            text-align: left;
            display: inline-block;
            padding: 0 1px;
            box-sizing: border-box;
            height: 100%;
            ul {
              width: 100%;
              display: flex;
              justify-content: flex-start;
            }
            .paper-item-col {
              width: auto;
              max-width: 95px;
              height: 70px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &::after {
                content: '/';
              }
              &:last-child {
                &::after {
                  content: '';
                }
              }
            }
          }
          .paper-logo {
            padding-left: 3px;
            width: 20px;
            height: 100%;
            .logo {
              display: inline-block;
              width: 17px;
              height: 17px;
              background: url('../../assets/images/user-logo.png') no-repeat
                center center;
              background-size: 100%;
              vertical-align: middle;
            }
          }
        }
        .affiliation {
          text-align: left;
          width: 12%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .count {
          width: 12%;
        }
        .citation {
          width: 12%;
        }
        .citation_share {
          width: 12%;
        }
        .hindex {
          width: 12%;
        }
        .venue {
          width: 25%;
          
          .paper-venue-white-space {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;
          }
        }
        .t2citation {
          width: 12%;
        }
        .trend {
          // width: 14%;
          text-align: center;
        }
      }
      .paper-detail {
        padding: 0 20px;
        box-sizing: border-box;
        width: 100%;
        background: #f7f8fa;
        .el-row {
          padding: 12px 0;
          font-size: 14px;
          .label {
            font-weight: 600;
          }
        }
      }
    }
  }
  #scatter-map {
    width: 100%;
    height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aceranking/kqi-paper.vue